import React from 'react';
import classNameBind from 'classnames/bind';
import Label from '../Label';
import Tooltip from '../Tooltip';
import Icon from '../Icon';
import Stack from '../Stack';
import styles from './WidgetContainer.module.css';

const bindClasses = classNameBind.bind(styles);

const WidgetContainer = ({
  title,
  children,
  withBorder,
  bottomHeaderBorder,
  widgetOptions,
  helpIcons,
  disabled,
  subdued,
  headerOnHover,
  fullHeight,
  refreshError,
  leftIcons,
}) => (
  <div
    className={bindClasses('wrapper', { disabled, withBorder, subdued, headerOnHover })}
    data-ppuc-id="WidgetContainer"
  >
    <div
      className={bindClasses('widgetTopBar', { headerOnHover, bottomHeaderBorder })}
      data-ppuc-id="WidgetContainer.top"
    >
      <Stack spacing="extraNarrow" verticalAlignment="center">
        <Stack.Item fill>
          <div className={`${bindClasses(
            'DashboardWidgetHandleContainer',
            'DashboardWidgetHandleContainerMain',
            { disabled },
          )}`}
          >
            {!disabled ? <Icon name="draggable" color="gray" /> : null}
            {leftIcons.map((icon, index) => (
              <span className={bindClasses('leftIcon')} key={index}>
                <Tooltip content={icon.text} title={icon.title}>
                  <span className={bindClasses({ 'spinning-icon': icon.icon === 'refresh' })}><Icon name={icon.icon} color={icon.color} /></span>
                </Tooltip>
              </span>
            ))}
            <div
              className={bindClasses(
                'widgetTopBarHandle',
                'widgetTopBarTitle',
                { 'with-icon': !!helpIcons.length || !!leftIcons.length },
              )}
              style={{
                maxWidth: (helpIcons.length > 0 || leftIcons.length > 0)
                  ? `calc(100% - ${leftIcons.length * 24 + helpIcons.length * 24 + (disabled ? -12 : 0)}px)`
                  : 'auto',
              }}
            >
              <Label noWrap cutText>
                {title}
              </Label>
            </div>
            {helpIcons.map((icon, index) => (
              <span className={bindClasses('icon')} key={index}>
                <Tooltip content={icon.text} title={icon.title}>
                  <span><Icon name={icon.icon} color={icon.color} /></span>
                </Tooltip>
              </span>
            ))}
          </div>
        </Stack.Item>
        <Stack.Item previousSpacing="narrow">
          {widgetOptions}
        </Stack.Item>
      </Stack>
    </div>
    <div
      className={bindClasses('widgetWrapper')}
      data-ppuc-id="WidgetContainer.body"
    >
      <div
        className={bindClasses('widgetWrapperChildren', { fullHeight, refreshError })}
        data-ppuc-id="WidgetContainer.children"
      >
        {children}
      </div>
    </div>
  </div>
);

WidgetContainer.defaultProps = {
  title: '',
  helpIcons: [],
  leftIcons: [],
  disabled: false,
  headerOnHover: false,
  bottomHeaderBorder: true,
  refreshError: false,
};

export default WidgetContainer;
